<template>
  <div>
    <table class="table table-striped serviceTable">
      <thead>
        <tr class="tr-table">
          <th scope="col">Nowość</th>
          <th scope="col">ID kategorii</th>
          <th scope="col">Nazwa</th>
          <th scope="col">Nazwa wyświetlana</th>
          <th scope="col">Opis</th>
          <th scope="col">Regulamin</th>
          <th scope="col">Ukryj</th>
          <th scope="col">Edytuj kategorię</th>
          <th scope="col">Kolejność</th>
          <th scope="col">Kolejność podkategorii</th>
          <th scope="col">Usuń kategorię</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in serviceCategoriesWithServices" :key="item.id">
          <td>
            <input
              type="checkbox"
              :ref="item.id"
              :checked="item.is_new"
              @change="handleNewCategories(item.id)"
            />
          </td>
          <td>{{ item.id }}</td>
          <td>{{ item.name }}</td>
          <td>{{ item.display_name }}</td>
          <td v-html="item.description ? item.description : 'Brak'"></td>
          <td>
            <div>
              <button
                type="button"
                class="btn btn-outline-dark mr-2"
                data-toggle="modal"
                data-target="#editRegulation"
                v-if="item.type !== 'NONE'"
                @click="setRegulationToEdit(item.regulations[0], item.id)"
              >
                Podgląd/Edycja
              </button>
              <button
                v-if="item.regulations && item.regulations[0]"
                type="button"
                class="btn btn-outline-dark"
                @click="downloadRegulation(item.regulations[0])"
              >
                Pobierz
              </button>
            </div>
          </td>
          <td>
            <span class="toggle">
              <p v-if="item.is_hidden">Tak</p>
              <i
                class="fas fa-toggle-on"
                v-if="item.is_hidden"
                @click="handleToggleIsHidden(item.id, item.is_hidden)"
              ></i>
              <p v-if="!item.is_hidden">Nie</p>
              <i
                class="fas fa-toggle-off"
                v-if="!item.is_hidden"
                @click="handleToggleIsHidden(item.id, item.is_hidden)"
              ></i>
            </span>
          </td>
          <td>
            <button
              type="button"
              class="btn btn-outline-dark"
              data-toggle="modal"
              data-target="#exampleModal"
              v-on:click="setCategoryServiceToEdit(item)"
            >
              Edytuj
            </button>
          </td>

          <td>
            <button
              v-if="item.services && item.services.length > 0"
              type="button"
              class="btn btn-outline-dark"
              data-toggle="modal"
              data-target="#servicesPriorityModal"
              @click="getServices(item.id)"
            >
              Edytuj kolejność
            </button>
            <span v-else>Brak usług w tej kategorii</span>
          </td>

          <td class="text-center">
            <button
              v-if="item.sub_categories && item.sub_categories.length > 0"
              type="button"
              class="btn btn-outline-dark"
              data-toggle="modal"
              data-target="#subCategoriesPriorityModal"
              @click="setSubCategories(item.sub_categories)"
            >
              Edytuj kolejność podkategorii
            </button>
            <span class="text-center" v-else>Brak podkategorii </span>
          </td>

          <td>
            <button
              class="btn btn-outline-dark"
              v-on:click="deleteCategoryServiceHandler(item)"
            >
              x
            </button>
          </td>
        </tr>
      </tbody>
    </table>

    <div
      class="modal fade"
      id="editRegulation"
      tabindex="-1"
      role="dialog"
      aria-labelledby="editRegulationLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-xl" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="editRegulationLabel">Regulamin</h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <html-editor
            class="regulation-textarea"
            @contentchanged="handleHtmlEditorContentForCategory($event)"
            :startContent="regulation ? regulation : ''"
          />
          <p
            style="font-weight: 700; margin-left: 1rem; font-size: 13px"
            v-if="hasRegulationFile"
          >
            Plik regulaminu został już dodany. Wybierając nowy plik, poprzedni
            zostanie usunięty
          </p>
          <div>
            <input type="file" @change="handleRegulationFile($event)" />
          </div>

          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-outline-dark"
              @click="saveRegulationChanges"
            >
              Zapisz zmiany
            </button>
            <button
              type="button"
              class="btn btn-outline-dark"
              data-dismiss="modal"
            >
              Zamknij
            </button>
          </div>
        </div>
      </div>
    </div>

    <div
      class="modal fade"
      id="exampleModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-xl" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Edytuj kategorię</h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <form class="topform" @submit="handleCategoryServiceUpdate($event)">
              <div class="input-container">
                <!-- <label>Wybierz typ:</label>
                <span >
                  <select v-model="serviceType" required class="form-control mb-2">
                    <option value="LUXMED">LUXMED</option>
                    <option value="NONE">NONE</option>
                  </select>
                </span> -->
                <label>Nazwa kategorii:</label>
                <input
                  v-model="name"
                  id="name"
                  type="text"
                  class="form-control"
                  required
                  minlength="1"
                />
              </div>
              <div class="input-container">
                <label>Nazwa do wyświetlania:</label>
                <input
                  v-model="displayName"
                  id="displayName"
                  type="text"
                  class="form-control"
                  required
                  minlength="1"
                />
              </div>
              <div class="input-container">
                <label>Rodzina karnetu:</label>
                <select v-model="carnetGroup" id="carnetGroup" class="form-control">
                  <option value="">Brak (zwykła kategoria)</option>
                  <option value="OBIADY">OBIADY - obiady domowe</option>
                </select>
                <small style="display: block; margin-top: 4px; color: #6c757d">
                  Decyduje o rozliczeniu jak obiad (VAT 8%, nabywcą klient, dział OD) i o tym, czy
                  zamówienia trafiają do zakładki Obiady. Ustawiaj tylko na kategoriach obiadowych.
                </small>
              </div>
              <div class="input-container">
                <label>
                  <input
                    v-model="hasCustomDescription"
                    id="hasCustomDescription"
                    type="checkbox"
                    style="margin-right: 6px"
                  />
                  Wybór opcji na kafelkach
                </label>
                <small style="display: block; margin-top: 4px; color: #6c757d">
                  Zaznaczone: klient wybiera wariant na osobnym ekranie z kafelkami (tak działają
                  obiady). Odznaczone: zwykłe okno z listą opcji. Zmiana od razu przestawia ekran
                  zamawiania tej kategorii w aplikacji i na webie. Kategorie typu LUXMED, CHOICES,
                  MDT i podobne mają kafelki wymuszone przez system niezależnie od tego pola.
                </small>
              </div>
              <div style="margin-top: 10px" class="photos-management">
                <h1
                  style="
                    text-transform: uppercase;
                    color: #090741;
                    font-weight: 600;
                    margin-bottom: 10px;
                  "
                >
                  Ikona usługi:
                </h1>
                <div class="grid-photos">
                  <div class="mobile">
                    <p
                      :style="
                        mobileFilesIcons.length > 0 ? 'margin-bottom:-15px' : ''
                      "
                    >
                      Ikona mobile (700x700) (.WebP)
                    </p>
                    <label
                      for="avatar3"
                      class="control__label galery-custom-btn"
                    >
                      <div
                        :class="
                          mobileFilesIcons.length > 0 ? '' : 'input-as-button'
                        "
                      >
                        {{ mobileFilesIcons.length > 0 ? "" : "Wybierz plik" }}
                      </div>
                    </label>
                    <input
                      @change="addNewMobileIconFile"
                      type="file"
                      id="avatar3"
                      accept=".webp"
                      style="display: none; width: 163px"
                    />
                    <div class="already-added">
                      <div
                        class="photo-added"
                        v-for="photo in mobileFilesIcons"
                        :key="photo.name || photo.filename"
                      >
                        {{
                          "icon" + photo.name
                            ? photo.name.substring(0, 20)
                            : photo.filename.substring(0, 20) + "..."
                        }}
                        <span @click="removePhoto(photo)" class="remove-pic"
                          >X</span
                        >
                      </div>
                    </div>
                  </div>
                  <div class="web">
                    <p
                      :style="
                        webFilesIcons.length > 0 ? 'margin-bottom:-15px' : ''
                      "
                    >
                      Ikona Web (2800x2800) (.WebP)
                    </p>
                    <label
                      for="avatar4"
                      class="control__label galery-custom-btn"
                    >
                      <div
                        :class="
                          webFilesIcons.length > 0 ? '' : 'input-as-button'
                        "
                      >
                        {{ webFilesIcons.length > 0 ? "" : "Wybierz plik" }}
                      </div>
                    </label>
                    <input
                      @change="addNewWebIconFile"
                      type="file"
                      id="avatar4"
                      accept=".webp"
                      style="display: none; width: 163px"
                    />
                    <div class="already-added">
                      <div
                        class="photo-added"
                        v-for="photo in webFilesIcons"
                        :key="photo.name"
                      >
                        {{ photo.name.substring(0, 20) + "..." }}
                        <span @click="removePhoto(photo)" class="remove-pic"
                          >X</span
                        >
                      </div>
                    </div>
                  </div>
                  <div class="web" style="order: 2">
                    <p style="margin-bottom: 4px">
                      Grafika na kafelek Web (proporcja 3,267:1) (.PNG/.JPG)
                    </p>
                    <ul
                      class="tile-hint"
                      :style="tileImageId ? 'margin-bottom:-15px' : ''"
                    >
                      <li>
                        Grafika dopasowuje się do <b>szerokości</b> kafelka i
                        zachowuje proporcje - <b>nic nie jest przycinane</b>.
                        Wysokość kafelka dostosowuje się do grafiki.
                      </li>
                      <li>
                        Zalecana proporcja <b>3,267:1</b> (np.
                        <b>980 x 300 px</b> lub 1307 x 400 px) - wtedy kafelek ma
                        naturalną wysokość. Inna proporcja też zadziała (kafelek
                        będzie wyższy lub niższy).
                      </li>
                      <li>
                        <b>PNG</b> dla logo z przezroczystym tłem,
                        <b>JPG</b> dla pełnej grafiki z własnym tłem.
                      </li>
                      <li>
                        Jedna grafika na kategorię - wgranie nowej zastępuje
                        poprzednią. Bez grafiki kafelek wygląda jak dotychczas.
                      </li>
                    </ul>
                    <label
                      for="avatar5"
                      class="control__label galery-custom-btn"
                    >
                      <div :class="tileImageId ? '' : 'input-as-button'">
                        {{ tileImageId ? "" : "Wybierz plik" }}
                      </div>
                    </label>
                    <input
                      @change="addNewTileFile"
                      type="file"
                      id="avatar5"
                      accept=".png,.jpg,.jpeg"
                      style="display: none; width: 163px"
                    />
                    <div class="already-added" v-if="tileImageId">
                      <div class="photo-added tile-preview">
                        <img :src="tileImageUrl" alt="Grafika kafelka" />
                        <span @click="removeTileFile" class="remove-pic">X</span>
                      </div>
                    </div>
                  </div>
                  <!-- order: kolumny w tym wierszu maja byc Mobile | Web, tak jak w wierszu
                       z ikonami wyzej; kolejnosc w markupie zostawiam web-first, zeby diff
                       byl mniejszy -->
                  <div class="mobile" style="order: 1">
                    <p style="margin-bottom: 4px">
                      Grafika na kafelek Mobile (proporcja 3,267:1) (.PNG/.JPG)
                    </p>
                    <ul
                      class="tile-hint"
                      :style="mobileTileImageId ? 'margin-bottom:-15px' : ''"
                    >
                      <li>
                        Zalecana proporcja <b>3,267:1</b> (np.
                        <b>980 x 300 px</b> lub 1307 x 400 px) - wtedy grafika
                        <b>wypełnia cały kafelek</b>.
                      </li>
                      <li>
                        Inna proporcja też zadziała, ale aplikacja nie przycina
                        grafiki - zostanie wtedy wolne miejsce po bokach lub u
                        góry i dołu.
                      </li>
                      <li>
                        <b>PNG</b> dla logo z przezroczystym tłem,
                        <b>JPG</b> dla pełnej grafiki z własnym tłem.
                      </li>
                      <li>
                        Grafika jest niezależna od webowej - aplikacja mobilna
                        użyje jej, gdy obsłuży to po swojej stronie. Do tego
                        czasu wgranie pliku niczego w aplikacji nie zmienia.
                      </li>
                    </ul>
                    <label
                      for="avatar6"
                      class="control__label galery-custom-btn"
                    >
                      <div :class="mobileTileImageId ? '' : 'input-as-button'">
                        {{ mobileTileImageId ? "" : "Wybierz plik" }}
                      </div>
                    </label>
                    <input
                      @change="addNewMobileTileFile"
                      type="file"
                      id="avatar6"
                      accept=".png,.jpg,.jpeg"
                      style="display: none; width: 163px"
                    />
                    <div class="already-added" v-if="mobileTileImageId">
                      <div class="photo-added tile-preview">
                        <img
                          :src="mobileTileImageUrl"
                          alt="Grafika kafelka mobile"
                        />
                        <span @click="removeMobileTileFile" class="remove-pic"
                          >X</span
                        >
                      </div>
                    </div>
                  </div>
                </div>
                <div class="line-through"></div>
                <h1
                  style="
                    text-transform: uppercase;
                    color: #090741;
                    font-weight: 600;
                    margin-bottom: 10px;
                  "
                >
                  Zdjęcia usługi:
                </h1>
                <div class="grid-photos">
                  <div class="mobile">
                    <p
                      :style="
                        mobileFilesPhotos.length > 0
                          ? 'margin-bottom:-15px'
                          : ''
                      "
                    >
                      Grafika mobile (756x328) (.PNG)
                    </p>
                    <label
                      for="avatar"
                      class="control__label galery-custom-btn"
                    >
                      <div
                        :class="
                          mobileFilesPhotos.length > 0
                            ? 'smaller-icon'
                            : 'input-as-button'
                        "
                      >
                        {{
                          mobileFilesPhotos.length > 0 ? "+" : "Wybierz plik"
                        }}
                      </div>
                    </label>
                    <input
                      @change="addNewMobilePhotoFile"
                      type="file"
                      id="avatar"
                      accept=".png"
                      style="display: none; width: 163px"
                    />
                    <div class="already-added">
                      <div
                        class="photo-added"
                        v-for="(photo, index) in mobileFilesPhotos"
                        :key="photo.name"
                      >
                        {{ photo.priority }}){{
                          photo.name.substring(0, 20) + "..."
                        }}
                        <div class="actions">
                          <img
                            v-if="index > 0"
                            style="cursor: pointer"
                            src="@/icons/pink-arrow.svg"
                            alt=""
                            @click="downThePosition(index, false)"
                          />
                          <img
                            v-if="index < mobileFilesPhotos.length - 1"
                            style="
                              transform: rotate(180deg);
                              margin-left: 5px;
                              cursor: pointer;
                            "
                            src="@/icons/pink-arrow.svg"
                            alt=""
                            @click="uppThePosition(index, false)"
                          />

                          <span @click="removePhoto(photo)" class="remove-pic"
                            >X</span
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="web">
                    <p
                      :style="
                        webFilesPhotos.length > 0 ? 'margin-bottom:-15px' : ''
                      "
                    >
                      Grafika Web (642x1052) (.PNG)
                    </p>
                    <label
                      for="avatar2"
                      class="control__label galery-custom-btn"
                    >
                      <div
                        :class="
                          webFilesPhotos.length > 0
                            ? 'smaller-icon'
                            : 'input-as-button'
                        "
                      >
                        {{ webFilesPhotos.length > 0 ? "+" : "Wybierz plik" }}
                      </div>
                    </label>
                    <input
                      @change="addNewWebPhotoFile"
                      type="file"
                      id="avatar2"
                      accept=".png"
                      style="display: none; width: 163px"
                    />
                    <div class="already-added">
                      <div
                        class="photo-added"
                        v-for="(photo, index) in webFilesPhotos"
                        :key="photo.name"
                      >
                        {{ photo.priority }})
                        {{ photo.name.substring(0, 20) + "..." }}
                        <div class="actions">
                          <img
                            v-if="index > 0"
                            style="cursor: pointer"
                            src="@/icons/pink-arrow.svg"
                            alt=""
                            @click="downThePosition(index, true)"
                          />
                          <img
                            v-if="index < webFilesPhotos.length - 1"
                            style="
                              transform: rotate(180deg);
                              margin-left: 5px;
                              cursor: pointer;
                            "
                            src="@/icons/pink-arrow.svg"
                            alt=""
                            @click="uppThePosition(index, true)"
                          />

                          <span @click="removePhoto(photo)" class="remove-pic"
                            >X</span
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="input-container">
                <label>Opis kategorii:</label>
                <p style="font-size: 14px">
                  <b>
                    W celu dodania zagnieżdzonej listy, należy dodać znacznik
                    NESTED-LIST oraz END-NESTED-LIST w miejscach gdzie ma się
                    rozpoczynać i kończyć zagnieżdżona lista
                  </b>
                </p>
                <div style="display: flex; align-items: center">
                  Przykład:
                  <img
                    src="../../images/nested-list-example.png"
                    alt="Nested list example"
                    style="
                      max-height: 1000px;
                      width: 200px;
                      height: 150px;
                      margin: 30px;
                      margin-top: 0px;
                    "
                  />
                  <img
                    src="../../images/nested-list-app-example.png"
                    alt="Nested list example"
                    style="
                      max-height: 1000px;
                      width: 300px;
                      height: 200px;
                      margin: 30px;
                    "
                  />
                </div>
                <html-editor
                  @contentchanged="handleHtmlEditorContent($event)"
                  :startContent="categoryDescriptionToEdit"
                />
              </div>
              <button class="buttonm btn btn-outline-dark mt-3" type="submit">
                Zapisz
              </button>
              <div v-if="categoryServiceUpdatedMessage">
                <p>{{ categoryServiceUpdatedMessage }}</p>
              </div>
            </form>
          </div>

          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-outline-dark"
              data-dismiss="modal"
            >
              Zamknij
            </button>
          </div>
        </div>
      </div>
    </div>

    <div
      class="modal fade"
      id="servicesPriorityModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="servicesPriorityModal"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-xl" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">
              Kolejność wyświetlania
            </h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <draggable
              v-model="myArray"
              group="people"
              @start="drag = true"
              @end="drag = false"
            >
              <div
                v-for="(element, index) in myArray"
                :key="element.id"
                class="element-container btn-outline-dark"
              >
                <p class="element">
                  {{ element.displayName }}
                  <span class="badge badge-danger">{{ index + 1 }}</span>
                </p>
              </div>
            </draggable>
            <button
              v-on:click="changeOrderHandler"
              class="btn btn-outline-dark"
            >
              Zaktualizuj kolejność
            </button>
          </div>

          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-outline-dark"
              data-dismiss="modal"
            >
              Zamknij
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- here -->
    <div
      class="modal fade"
      id="subCategoriesPriorityModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="subCategoriesPriorityModal"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-xl" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">
              Kolejność wyświetlania
            </h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <draggable
              v-model="subCategories"
              group="people"
              @start="drag = true"
              @end="drag = false"
            >
              <div
                v-for="(element, index) in subCategories"
                :key="element.id"
                class="element-container btn-outline-dark"
              >
                <p class="element">
                  {{ element.display_name }}
                  <span class="badge badge-danger">{{ index + 1 }}</span>
                </p>
              </div>
            </draggable>
            <button
              v-on:click="changeSubcategoriesOrderHandler"
              class="btn btn-outline-dark"
            >
              Zaktualizuj kolejność
            </button>
          </div>

          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-outline-dark"
              data-dismiss="modal"
            >
              Zamknij
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios, { URL as API_URL } from "../../axios";
import draggable from "vuedraggable";
import HtmlEditor from "../../components/HtmlEditor.vue";
export default {
  components: {
    draggable,
    HtmlEditor,
  },
  name: "ServicesCategories",
  computed: {
    tileImageUrl() {
      return this.tileImageId
        ? `${API_URL}/api/serviceCategoryFile/${this.tileImageId}`
        : "";
    },
    mobileTileImageUrl() {
      return this.mobileTileImageId
        ? `${API_URL}/api/serviceCategoryFile/${this.mobileTileImageId}`
        : "";
    },
    categoryServiceUpdatedMessage() {
      return this.$store.getters.getCategoryServiceUpdateMessage;
    },
    categoryServiceDeleteSuccessMessage() {
      return this.$store.getters.getDeleteServiceSuccess;
    },
    categoryServiceDeleteFailMessage() {
      return this.$store.getters.getDeleteServiceFail;
    },
    serviceCategoriesWithServices() {
      return this.$store.getters.getServiceCategoryWithServices;
    },
  },
  created() {
    this.$store.dispatch("fetchServiceCategoriesWithServices");
    this.fetchAgain();
    this.mobileFilesPhotos = [];
    this.mobileFilesIcons = [];
    this.webFilesPhotos = [];
    this.webFilesIcons = [];
  },
  data: function () {
    return {
      serviceType: "",
      categoryServiceId: "",
      name: "",
      displayName: "",
      carnetGroup: "",
      hasCustomDescription: false,
      myArray: [],
      subCategories: [],
      categoryDescription: "",
      regulation: "",
      regulationFile: null,
      categoryId: "",
      hasRegulationFile: false,
      categoryDescriptionToEdit: "",
      originalFiles: [],
      mobileFilesPhotos: [],
      mobileFilesIcons: [],
      webFilesPhotos: [],
      webFilesIcons: [],
      // Grafiki kafelka (SAPP00029) nie wracaja w `files` - backend podaje same id
      // w web_tile_image / mobile_tile_image.
      tileImageId: "",
      mobileTileImageId: "",
    };
  },
  methods: {
    handleHtmlEditorContentForCategory(content) {
      this.regulation = content;
    },
    handleHtmlEditorContent(content) {
      this.categoryDescription = content;
    },
    handleRegulationFile(e) {
      this.regulationFile = e.target.files[0];
    },
    async handleToggleIsHidden(id, hidden) {
      const obj = {
        categoryServiceId: id,
        is_hidden: !hidden,
      };
      this.$store.dispatch("updateCategoryService", obj);
      this.$store.dispatch("fetchServiceCategoriesWithServices");
    },
    async saveRegulationChanges() {
      try {
        const url = `api/serviceCategoryRegulation`;
        const fd = new FormData();
        fd.append("text", this.regulation);
        fd.append("file", this.regulationFile);
        fd.append("serviceCategoryId", this.categoryId);
        await axios.put(url, fd);
        this.$notify({
          group: "success",
          text: "Pomyślnie edytowano regulamin",
        });
        this.$store.dispatch("fetchServiceCategoriesWithServices");
      } catch (error) {
        console.log(error);
        this.$notify({
          group: "error",
          text: error,
        });
      }
    },
    setRegulationToEdit(regulation, categoryId) {
      if (regulation) {
        if (regulation.filePath) {
          this.hasRegulationFile = true;
        }
        this.regulation = regulation.text;
      } else {
        this.hasRegulationFile = false;
        this.regulation = "";
      }

      this.categoryId = categoryId;
    },
    async downloadRegulation(regulation) {
      const url = `api/serviceCategoryRegulation/file/${regulation.filePath}`;
      axios(url, {
        method: "GET",
        responseType: "blob",
      })
        .then((response) => {
          const fileURL = window.URL.createObjectURL(new Blob([response.data]));
          const fileLink = document.createElement("a");

          fileLink.href = fileURL;
          fileLink.setAttribute("download", "regulation.pdf");
          document.body.appendChild(fileLink);
          fileLink.click();
        })
        .catch((err) => console.log(err));
    },
    handleNewCategories(serviceCategoryId) {
      const isNew = this.$refs[`${serviceCategoryId}`][0].checked;
      const url = `api/serviceCategory/${serviceCategoryId}/new?isNew=${isNew}`;
      axios.put(url);
    },
    getServices(categoryId) {
      const url = `api/service/serviceCategory/${categoryId}`;
      axios
        .get(url, {
          headers: {
            "Content-Type": "application/json",
          },
        })
        .then((response) => {
          this.myArray = response.data.map((item) => {
            return {
              id: item.id,
              name: item.description,
              displayName: item.display_name,
              type: item.serviceCategoryEntity.type,
            };
          });
        })
        .catch(() => {
          this.errorMessage = "Nie udało się wczytać usług";
        });
    },

    changeOrderHandler() {
      const ids = this.myArray.map((item) => item.id);

      const url = "api/service/priority";
      const body = JSON.stringify({ services: ids });

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      axios
        .post(url, body, config)
        .then((res) => {
          this.successMessage = res.data.message;
          setTimeout(() => (this.successMessage = ""), 3000);
        })
        .catch(() => {
          this.errorMessage = "Wystąpił błąd przy zmianie kolejności";
          setTimeout(() => (this.errorMessage = ""), 3000);
        });
    },
    changeSubcategoriesOrderHandler() {
      const ids = this.subCategories.map((item) => item.id);
      const url = "api/subCategory/priority";
      const body = JSON.stringify({ services: ids });

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      axios
        .post(url, body, config)
        .then(() => {
          this.$notify({
            group: "success",
            text: "Pomyślnie edytowano kolejność",
          });
        })
        .catch(() => {
          this.$notify({
            group: "error",
            text: "Wystąpił błąd przy zmianie kolejności",
          });
        });

      this.fetchAgain();
    },

    deleteCategoryServiceHandler(categoryService) {
      const confirmed = prompt(
        `Czy na pewno chcesz usunąć kategorię ${categoryService.name}? Potwierdź wpisując nazwę usługi`,
        ""
      );
      if (confirmed === categoryService.name) {
        this.$store.dispatch("deleteCategoryServiceById", {
          categoryServiceId: categoryService.id,
        });
      }
    },

    async fetchAgain() {
      await this.$store.dispatch("fetchServiceCategoriesWithServices");
    },
    setCategoryServiceToEdit(categoryService) {
      this.mobileFilesPhotos = [];
      this.mobileFilesIcons = [];
      this.webFilesPhotos = [];
      this.webFilesIcons = [];
      this.tileImageId = categoryService.web_tile_image || "";
      this.mobileTileImageId = categoryService.mobile_tile_image || "";
      this.originalFiles = categoryService.files;
      if (categoryService.files) {
        categoryService.files.forEach((file) => {
          file.name = file.id;

          if (file.os === "MOBILE") {
            if (file.type === "ICON") {
              // file.priority = this.mobileFilesIcons.length + 1;
              this.mobileFilesIcons.push(file);
            }
            if (file.type === "IMAGE") {
              // file.priority = this.mobileFilesPhotos.length + 1;
              this.mobileFilesPhotos.push(file);
            }
          }
          if (file.os === "WEB") {
            if (file.type === "ICON") this.webFilesIcons.push(file);
            if (file.type === "IMAGE") {
              // file.priority = this.webFilesPhotos.length + 1;
              this.webFilesPhotos.push(file);
            }
          }
        });
      }
      this.mobileFilesPhotos = this.mobileFilesPhotos.sort(function (
        photo,
        nextPhoto
      ) {
        return photo.priority - nextPhoto.priority;
      });
      this.webFilesPhotos = this.webFilesPhotos.sort(function (
        photo,
        nextPhoto
      ) {
        return photo.priority - nextPhoto.priority;
      });
      this.categoryServiceId = categoryService.id;
      this.serviceType = categoryService.type;
      this.name = categoryService.name;
      this.displayName = categoryService.display_name;
      this.carnetGroup = categoryService.carnet_group || "";
      this.hasCustomDescription = categoryService.has_custom_description === true;
      console.log({ a: categoryService.description });
      this.categoryDescription = categoryService.description;
      this.categoryDescriptionToEdit = categoryService.description;
    },

    async handleCategoryServiceUpdate(e) {
      e.preventDefault();
      if (!this.categoryDescription) {
        this.$notify({
          group: "error",
          text: "Niepoprawny opis",
        });
        return;
      }

      const tmp = document.createElement("DIV");
      tmp.innerHTML = this.categoryDescription;
      const textWithoutHTMLMarks = tmp.textContent || tmp.innerText || "";
      if (textWithoutHTMLMarks && textWithoutHTMLMarks.length > 2048) {
        this.$notify({
          group: "error",
          text: `Zbyt długi opis kategorii. Maksymalna długość to 2048 znaków. Twój opis zawiera ${textWithoutHTMLMarks.length} znaków`,
        });
        return;
      }

      const data = {
        categoryServiceId: this.categoryServiceId,
        type: this.serviceType,
        name: this.name,
        description: this.categoryDescription,
        displayName: this.displayName,
        carnet_group: this.carnetGroup,
        has_custom_description: this.hasCustomDescription,
      };

      await this.$store.dispatch("updateCategoryService", data);
      await this.fetchAgain();
      this.$notify({
        group: "success",
        text: "Zapisano kategorię",
      });
    },
    setSubCategories(categories) {
      this.subCategories = categories;
    },
    async addNewWebPhotoFile(e) {
      if (
        this.getFileExtension(e.target.files[0].name).toLowerCase() === "png"
      ) {
        let f = e.target.files[0];
        let body = new FormData();
        body.append("file", f);
        body.append("type", "IMAGE");
        body.append("os", "WEB");
        body.append("serviceCategoryId", this.categoryServiceId);
        const file = await this.$store.dispatch("addServiceCategoryFile", body);
        if (!file) {
          return;
        }
        file.name = file.id;
        this.webFilesPhotos.push(file);
      } else {
        this.$notify({
          group: "error",
          text: "Dodany plik jest nieprawidłowy",
        });
      }
    },
    async addNewMobilePhotoFile(e) {
      if (
        this.getFileExtension(e.target.files[0].name).toLowerCase() === "png"
      ) {
        let f = e.target.files[0];
        let body = new FormData();
        body.append("file", f);
        body.append("type", "IMAGE");
        body.append("os", "MOBILE");
        body.append("serviceCategoryId", this.categoryServiceId);
        const file = await this.$store.dispatch("addServiceCategoryFile", body);
        if (!file) {
          return;
        }
        file.name = file.id;
        this.mobileFilesPhotos.push(file);
      } else {
        this.$notify({
          group: "error",
          text: "Dodany plik jest nieprawidłowy",
        });
      }
    },
    async addNewMobileIconFile(e) {
      if (
        this.getFileExtension(e.target.files[0].name).toLowerCase() === "webp"
      ) {
        let body = new FormData();
        body.append("file", e.target.files[0]);
        body.append("type", "ICON");
        body.append("os", "MOBILE");
        body.append("serviceCategoryId", this.categoryServiceId);
        const file = await this.$store.dispatch("addServiceCategoryFile", body);
        if (!file) {
          return;
        }
        file.name = file.id;
        this.mobileFilesIcons.push(file);
      } else {
        this.$notify({
          group: "error",
          text: "Dodany plik jest nieprawidłowy",
        });
      }
    },
    async addNewWebIconFile(e) {
      if (
        this.getFileExtension(e.target.files[0].name).toLowerCase() === "webp"
      ) {
        let body = new FormData();
        body.append("file", e.target.files[0]);
        body.append("type", "ICON");
        body.append("os", "WEB");
        body.append("serviceCategoryId", this.categoryServiceId);
        const file = await this.$store.dispatch("addServiceCategoryFile", body);
        if (!file) {
          return;
        }
        file.name = file.id;
        this.webFilesIcons.push(file);
      } else {
        this.$notify({
          group: "error",
          text: "Dodany plik jest nieprawidłowy",
        });
      }
    },
    // One tile per category and os: the backend removes the previous one on upload, so no DELETE
    // is sent from here (an id remembered by the modal can be stale and the 404 left the old tile in place).
    // Web and mobile differ only in `os` and in the field that keeps the id.
    async uploadTileFile(e, os) {
      const extension = this.getFileExtension(
        e.target.files[0].name
      ).toLowerCase();
      if (!["png", "jpg", "jpeg"].includes(extension)) {
        this.$notify({
          group: "error",
          text: "Dodany plik jest nieprawidłowy (dozwolone: PNG, JPG)",
        });
        return null;
      }
      let body = new FormData();
      body.append("file", e.target.files[0]);
      body.append("type", "TILE");
      body.append("os", os);
      body.append("serviceCategoryId", this.categoryServiceId);
      const file = await this.$store.dispatch("addServiceCategoryFile", body);
      return file && file.id ? file.id : null;
    },
    async addNewTileFile(e) {
      const fileId = await this.uploadTileFile(e, "WEB");
      if (fileId) {
        this.tileImageId = fileId;
      }
    },
    async addNewMobileTileFile(e) {
      const fileId = await this.uploadTileFile(e, "MOBILE");
      if (fileId) {
        this.mobileTileImageId = fileId;
      }
    },
    async removeTileFile() {
      if (!this.tileImageId) {
        return;
      }
      const removed = await this.$store.dispatch(
        "removeServiceCategoryFile",
        this.tileImageId
      );
      if (removed) {
        this.tileImageId = "";
      }
    },
    async removeMobileTileFile() {
      if (!this.mobileTileImageId) {
        return;
      }
      const removed = await this.$store.dispatch(
        "removeServiceCategoryFile",
        this.mobileTileImageId
      );
      if (removed) {
        this.mobileTileImageId = "";
      }
    },
    getFileExtension(filename) {
      return filename ? filename.split(".").pop() : "";
    },
    async uppThePosition(index, web) {
      if (web) {
        let tmp = this.webFilesPhotos[index].priority;
        this.webFilesPhotos[index].priority =
          this.webFilesPhotos[index + 1].priority;
        this.webFilesPhotos[index + 1].priority = tmp;
        await this.$store.dispatch("setServiceCategoryFilePriority", {
          id: this.webFilesPhotos[index].id,
          priority: this.webFilesPhotos[index].priority,
        });
      } else {
        let tmp = this.mobileFilesPhotos[index].priority;
        this.mobileFilesPhotos[index].priority =
          this.mobileFilesPhotos[index + 1].priority;
        this.mobileFilesPhotos[index + 1].priority = tmp;
        await this.$store.dispatch("setServiceCategoryFilePriority", {
          id: this.mobileFilesPhotos[index].id,
          priority: this.mobileFilesPhotos[index].priority,
        });
      }
      this.mobileFilesPhotos = this.mobileFilesPhotos.sort(function (
        photo,
        nextPhoto
      ) {
        return photo.priority - nextPhoto.priority;
      });
      this.webFilesPhotos = this.webFilesPhotos.sort(function (
        photo,
        nextPhoto
      ) {
        return photo.priority - nextPhoto.priority;
      });
    },
    async downThePosition(index, web) {
      if (web) {
        let tmp = this.webFilesPhotos[index].priority;
        this.webFilesPhotos[index].priority =
          this.webFilesPhotos[index - 1].priority;
        this.webFilesPhotos[index - 1].priority = tmp;
        await this.$store.dispatch("setServiceCategoryFilePriority", {
          id: this.webFilesPhotos[index].id,
          priority: this.webFilesPhotos[index].priority,
        });
      } else {
        let tmp = this.mobileFilesPhotos[index].priority;
        this.mobileFilesPhotos[index].priority =
          this.mobileFilesPhotos[index - 1].priority;
        this.mobileFilesPhotos[index - 1].priority = tmp;
        await this.$store.dispatch("setServiceCategoryFilePriority", {
          id: this.mobileFilesPhotos[index].id,
          priority: this.mobileFilesPhotos[index].priority,
        });
      }
      this.mobileFilesPhotos = this.mobileFilesPhotos.sort(function (
        photo,
        nextPhoto
      ) {
        return photo.priority - nextPhoto.priority;
      });
      this.webFilesPhotos = this.webFilesPhotos.sort(function (
        photo,
        nextPhoto
      ) {
        return photo.priority - nextPhoto.priority;
      });
    },
    async removePhoto(photo) {
      for (let i = 0; i < this.webFilesPhotos.length; i++) {
        if (photo.name === this.webFilesPhotos[i].name) {
          await this.$store.dispatch(
            "removeServiceCategoryFile",
            this.webFilesPhotos[i].id
          );
          this.webFilesPhotos.splice(i, 1);
        }
      }
      for (let j = 0; j < this.webFilesIcons.length; j++) {
        if (photo.name === this.webFilesIcons[j].name) {
          await this.$store.dispatch(
            "removeServiceCategoryFile",
            this.webFilesIcons[j].id
          );
          this.webFilesIcons.splice(j, 1);
        }
      }
      for (let k = 0; k < this.mobileFilesPhotos.length; k++) {
        if (photo.name === this.mobileFilesPhotos[k].name) {
          await this.$store.dispatch(
            "removeServiceCategoryFile",
            this.mobileFilesPhotos[k].id
          );
          this.mobileFilesPhotos.splice(k, 1);
        }
      }
      for (let l = 0; l < this.mobileFilesIcons.length; l++) {
        if (photo.name === this.mobileFilesIcons[l].name) {
          await this.$store.dispatch(
            "removeServiceCategoryFile",
            this.mobileFilesIcons[l].id
          );
          this.mobileFilesIcons.splice(l, 1);
        }
      }
    },
  },
};
</script>

<style scoped>
.text-center {
  text-align: center;
}
img {
  max-height: 20px;
  height: 100%;
  width: auto;
}
.iconImg {
  max-width: 200px;
  max-height: 200px;
  padding: 25px;
}

.iconModal {
  background: rgb(56, 55, 55);
  color: white;
}
.iconLink {
  margin-bottom: 6px;
  background: white;
  border-radius: 4px;
  border: 1px solid grey;
  width: 50px;
  margin: 3px;
  background: rgb(53, 51, 51);
  color: white;
}
.iconLink img {
  color: white;
  margin: 0 auto;
}
.iconLink:hover {
  color: rgb(20, 136, 55);
  cursor: pointer;
}
.inputButtonLabel {
  cursor: pointer;
}
.inputButtonLabel:hover {
  background: rgb(49, 45, 45);
  color: white;
}
.serviceTable:hover,
tr:hover {
  cursor: default !important;
}
div.container {
  display: flex;

  padding-top: 10px;
}
button.btn {
  margin-left: 20px;
}
.input-container label {
  margin: 10px 0px 0px 0px;
}

.noPromotion,
.promotion {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-content: center;
  width: 100px;
}
.promotion button,
.noPromotion button {
  margin: 0 auto;
  margin-top: 5px;
}
.deletePromotionButton {
  color: red;
  position: absolute;
  right: 5px;
  top: 5px;
}
.inputButtonLabel {
  border: 1px solid rgb(66, 64, 64);
  padding: 5px;
  margin-top: 5px;
  border-radius: 5px;
}
div.container {
  display: flex;
  flex-direction: column;
  padding-top: 10px;
  text-align: center;
}
div.element-container {
  margin: 0 auto;
  border-radius: 5px;
  margin-top: 10px;
  justify-content: center;
  display: flex;
  height: 30px;
  width: 300px;
}
p.element {
  text-align: center;
}
.updateButton {
  width: 300px;
  margin-top: 30px;
}
.badge-danger {
  background: #fb8928;
  color: #090741;
  border-radius: 5px;
  width: 13px;
  text-align: center;
}
.btn-outline-dark:hover {
  background: #fb8928 !important;
}
.regulation-textarea {
  width: 100%;
  min-height: 50vh;
}
.toggle {
  margin-right: 10px;
  display: flex;
  justify-content: center;
}
.toggle i {
  margin-left: 1rem;
  font-size: 18px;
  cursor: pointer;
}
.input-as-button,
.photo-added {
  width: 334px;
  height: 32px;
  background: rgba(9, 7, 65, 0.02);
  border: 1px solid rgba(9, 7, 65, 0.25);
  border-radius: 3px;
  cursor: pointer;
  display: grid;
  place-items: center;
}

.photo-added {
  display: flex;
  justify-content: space-between;
  padding: 0 10px;
  cursor: auto;
}
/* Krótka instrukcja przy uploadzie grafiki kafelka - wymagania rozmiaru i tła. */
.tile-hint {
  margin: 0 0 10px;
  padding-left: 16px;
  max-width: 334px;
  font-size: 11px;
  line-height: 15px;
  color: rgba(9, 7, 65, 0.65);
}
.tile-hint li {
  margin-bottom: 2px;
}
/* Podgląd grafiki kafelka - miniatura zamiast nazwy pliku, bo ten plik nie wraca w `files`. */
.tile-preview {
  height: auto;
  min-height: 32px;
  align-items: center;
}
.tile-preview img {
  max-height: 60px;
  max-width: 280px;
  object-fit: contain;
}
.photo-added {
  margin-left: -5px;
  margin-top: 5px;
}
.remove-pic {
  color: #ec0909;
  padding-left: 20px;
  cursor: pointer;
}
.grid-photos {
  display: grid;
  grid-template-columns: 50% 50%;
}
.mobile,
.web {
  position: relative;
}
.smaller-icon {
  position: absolute;
  color: #e2037e;
  font-size: 30px;
  top: -15px;
  left: 310px;
  cursor: pointer;
}
.line-through {
  width: 100%;
  max-height: 1px;
  box-shadow: rgba(17, 17, 26, 0.1) 0px 1px 0px;
  margin-bottom: 30px;
}
</style>
